import ImportImages from '@src/importImages';

const P100_1 = ImportImages('/ouraircraft/p300/1.jpg');
const P100_2 = ImportImages('/ouraircraft/p300/2.jpg');
const P100_3 = ImportImages('/ouraircraft/p300/3.jpg');
const P100_4 = ImportImages('/ouraircraft/p300/4.jpg');
const P100_5 = ImportImages('/ouraircraft/p300/5.jpg');
const P100_6 = ImportImages('/ouraircraft/p300/6.jpg');
const P100_7 = ImportImages('/ouraircraft/p300/7.jpg');
const P300Performance = ImportImages('/ouraircraft/p300.png');
const P300RangeMap = ImportImages('/ouraircraft/p300/P300_RangeMap.png');
const P300Lopa = ImportImages('/ouraircraft/p300/P300_Lopa.png');

const P300DEtails = {
  header: 'Phenom 300',
  content:
    'As the world’s best-selling business jet for six years and counting, the Phenom 300 accommodates up to' +
    ' seven passengers and features generous cabin space, a revolutionary interior, and top-class speed and' +
    ' range.',
  images: [P100_1, P100_2, P100_3, P100_4, P100_5, P100_6, P100_7],
  overview: [
    {
      title: 'Crew',
      content: '2 pilots'
    },
    {
      title: 'Passenger Capacity',
      content: '7 passengers'
    },
    {
      title: 'Cabin Length',
      content: '17ft. 2in'
    },
    {
      title: 'Cabin Height',
      content: '5ft'
    },
    {
      title: 'Cabin Width',
      content: '5ft 1in'
    },
    {
      title: 'Baggage Capacity',
      content: '76ft<sup>3</sup>'
    }
  ],
  performance: P300Performance,
  rangeMap: P300RangeMap,
  lopa: P300Lopa
};

export default P300DEtails;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/P300Details.js